import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from "@madmedical/routing";
import { MainLayout } from "@madmedical/ui";
import { PatientSelect, useIsActive, useMe } from "@madmedical/user";
import { useMemo } from "react";
import { useAppConfig } from "@madmedical/config";
import { UnderlyingCondition } from "@madmedical/medical";
import TestMenu from "./TestMenu";
import RoutingProvider from "./RoutingProvider";
const Main = () => {
    const { integrator } = useAppConfig();
    const isActive = useIsActive();
    const { patient, roles: { isPatient, isRepresentative }, } = useMe();
    const bottomNavigation = useMemo(() => {
        var _a, _b;
        if ((!isPatient && !isRepresentative) || isActive("preop", {})) {
            return undefined;
        }
        if (!isPatient && isRepresentative) {
            return [
                {
                    iconName: "heart",
                    route: "dashboard",
                    params: {},
                },
                {
                    iconName: "reportData",
                    route: "opinions",
                    params: {},
                },
                {
                    iconName: "documentView",
                    route: "documents_general",
                    params: {},
                },
            ];
        }
        const onlyBasicPackage = (_a = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _a === void 0 ? void 0 : _a.every((p) => p.type === "basic");
        const isInsulin = (patient === null || patient === void 0 ? void 0 : patient.underlyingConditions.includes(UnderlyingCondition.Insulin)) && ((_b = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _b === void 0 ? void 0 : _b.some((p) => p.type === "diabetes"));
        if (onlyBasicPackage) {
            return [
                {
                    iconName: "heart",
                    route: "dashboard",
                    params: {},
                },
                {
                    iconName: "devices",
                    route: "devices_connected",
                    params: {},
                },
            ];
        }
        return [
            {
                iconName: "heart",
                route: "dashboard",
                params: {},
            },
            {
                iconName: "devices",
                route: "devices_connected",
                params: {},
            },
            {
                iconName: "reportData",
                route: "opinions",
                params: {},
            },
            {
                iconName: "userAdmin",
                route: "representatives",
                params: {},
            },
            ...(isInsulin
                ? [
                    {
                        iconName: "alarm",
                        route: "insulin_reminders",
                        params: {},
                    },
                ]
                : []),
            {
                iconName: "documentView",
                route: "documents_general",
                params: {},
            },
        ];
    }, [
        isActive,
        isPatient,
        isRepresentative,
        patient === null || patient === void 0 ? void 0 : patient.packages,
        patient === null || patient === void 0 ? void 0 : patient.underlyingConditions,
    ]);
    return (_jsx(RoutingProvider, { children: _jsxs(MainLayout, Object.assign({ bottomNavigation: bottomNavigation, sidebar: integrator ? undefined : _jsx(TestMenu, {}), isRepresentative: isRepresentative }, { children: [_jsx(PatientSelect, {}), _jsx(Outlet, {})] })) }));
};
export default Main;
